<div class="bank-wrap">
  <!-- New Addition -->
  <div class="bank-acc-list" *ngIf="isMultiBank && isAccountConfirmed">
    <div class="secondary-tab">
      <div class="tab-item" [class.active]="bankAcc == i" (click)="bankAcc = i" *ngFor="let bank of bankdetails; index as i;"><span class="mob-hide">Bank</span> Account {{i+1}}</div>
      <!-- <div class="tab-item" [class.active]="bankAcc == 2" (click)="bankAcc = 2">Bank Account 2</div>
      <div class="tab-item" [class.active]="bankAcc == 3" (click)="bankAcc = 3">Bank Account 3</div> -->
    </div>
    <div class="text-link" (click)="addAccount()">Add <span class="mob-hide">Account</span></div>
  </div>
  <div class="cus-row">

    <div class="col-3 form-group">
      <label class="form-label">Bank Name <span class="mandatory">*</span></label>
      <p-autoComplete #autocomplete *ngIf="!activeAccount.isReadOnly" [suggestions]="suggestedBanklist" (input)="errors.bankName =''"  [(ngModel)]="activeAccount.bankName" field="name"
      (completeMethod)="search($event, {})" (click)="search({query:''}, autocomplete)" placeholder="Enter Name"></p-autoComplete>
      <input class="cus-input" type="text" *ngIf="activeAccount.isReadOnly" [readOnly]="activeAccount.isReadOnly" [(ngModel)]="activeAccount.bankName" placeholder="Enter name"/>
      <p *ngIf="errors.bankName" class="cus-input error">{{errors.bankName}}</p>
    </div>

    <div class="col-3 form-group">
      <label class="form-label">Account Number <span class="mandatory">*</span></label>
      <input class="cus-input" [readOnly]="activeAccount.isReadOnly" type="text" (input)="validateAccountNumber($event,false)"  [(ngModel)]="activeAccount.accountNo" placeholder="Enter account number" allowOnlyNumber/>
      <p *ngIf="errors.accountNo && !isAccountNumberMasked" class="cus-input error">{{errors.accountNo}}</p>
    </div>
    <!-- New Addition -->
    <div class="col-3 form-group" *ngIf="isAccountNumberMasked">
      <label class="form-label">Confirm Account Number <span class="mandatory">*</span></label>
      <input class="cus-input" id="confirmAccountnumer" [(ngModel)]="confirmAccountnumer" (input)="validateAccountNumber($event,true)" type="text" placeholder="Enter account number" allowOnlyNumber/>
      <p *ngIf="errors.accountNo" class="cus-input error">{{errors.accountNo}}</p>
    </div>
    <div class="col-3 form-group">
      <label class="form-label">IFSC Code <span class="mandatory">*</span></label>
      <input class="cus-input" type="text" [readOnly]="activeAccount.isReadOnly && activeAccount.isIfscReadonly" [(ngModel)]="activeAccount.ifsc" (input)="resetErros('ifsc')" placeholder="Enter code" IFSCCODEValidation/>
      <p *ngIf="errors.ifsc" class="cus-input error">{{errors.ifsc}}</p>
    </div>

    <div class="col-3 form-group">
      <label class="form-label">Bank Account Holder Name <span class="mandatory">*</span></label>
      <input class="cus-input" type="text" [(ngModel)]="activeAccount.name" [readOnly]="activeAccount.isReadOnly" placeholder="Enter name"/>
    </div>
  </div>
  <!-- Adding for mobile view -->
  <span *ngIf="isMultiBank && isAccountConfirmed && util.isMobile" class="text-link remove" (click)="showDialog()" >  {{'Remove Account '+(this.bankAcc+1)}}</span>
  <div class="page-action" *ngIf="!showAggrigator">
    <span *ngIf="isMultiBank && isAccountConfirmed && !util.isMobile|| isAccountAggrigator" class="text-link remove" (click)="showDialog()" >  {{'Remove Account '+(this.bankAcc+1)}}</span>
    <button class="btn-primary" [disabled]="!isFormValidate" (click)="submit()">Continue</button>
  </div>

</div>
<app-account-aggregator *ngIf="showAggrigator" (entityId)="getBankConnectUpload($event)"></app-account-aggregator>


<p-dialog [(visible)]="discardDialog" [modal]="true" styleClass="cus-dialog-md cus-dialog alert-dialog" [draggable]="false" [resizable]="false">
  <div class="alert-inner">
    <div class="gradient-line dark"></div>
    <div class="left">
      <img src="assets/images/dialog/mandate_info.svg" alt="Loader Image" />
    </div>
    <div class="right">
      <div class="alert-title">Are you sure?</div>
      <div class="alert-info">Do you wish to <span class="highlight alert">discard <span class="wrap-text">all the details</span> of the</span> bank account {{this.bankAcc+1}}?</div>
      <div class="alert-action">
        <button class="btn-primary" (click)="removeBackAccount()">Yes, I’d like to discard</button>
      </div>
    </div>
  </div>
</p-dialog>
